import { BasicActionDialog } from 'features/ui/base-dialogs';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';

interface Props {
  open: boolean;
  newFolderName: string;

  handleLeadTagFolderNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleCloseAddLeadTagFolderDialog(): void;

  handleAddLeadTagFolder(): void;
}

const AddFolderDialog: React.FC<Props> = ({
  open,
  newFolderName,
  handleLeadTagFolderNameChange,
  handleCloseAddLeadTagFolderDialog,
  handleAddLeadTagFolder,
}) => {
  return (
    <BasicActionDialog
      open={open}
      dialogTitle={'Ordner hinzufügen'}
      maxWidth={'xs'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Hinzufügen'}
      handleClose={handleCloseAddLeadTagFolderDialog}
      handleProceed={handleAddLeadTagFolder}
    >
      <PaiTextField value={newFolderName} placeholder={'Hier Name des Ordners eingeben...'} onChange={handleLeadTagFolderNameChange} />
    </BasicActionDialog>
  );
};

export default AddFolderDialog;
